<template>
  <div>
    <v-container class="fill-height pa-0" fluid>
      <v-row class="fill-height pa-0 mx-0 my-auto">
        <v-col cols="12" class="d-flex pa-0 text-center justify-center">
          <p
            v-if="evaluation.type === 'equipment'"
            class="font-weight-bold neutral--text pb-4 pt-6"
          >
            Evaluate Equipment
          </p>
          <p
            v-else-if="evaluation.type === 'patent'"
            class="font-weight-bold neutral--text pb-4 pt-6"
          >
            Evaluate Patent
          </p>
          <p v-else class="font-weight-bold neutral--text pb-4 pt-6">
            Evaluate Service
          </p>
        </v-col>
        <v-col cols="12" class="pa-0" v-if="!evaluationSubmitted">
          <v-form ref="form" v-model="valid" :lazy-validation="false">
            <v-row>
              <v-col cols="12">
                <label>Rating</label>
                <v-rating v-model="evaluation.stars" color="primary" hover length="5"></v-rating>
              </v-col>
              <v-col cols="12">
                <label>Feedback</label>
                <v-textarea
                  class="mt-2"
                  v-model="evaluation.feedback"
                  :placeholder="'Feedback'"
                  outlined
                  clearable
                  :rules="maxLengthRule(255)"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>

          <v-col cols="12">
            <v-btn
              :disabled="!valid || evaluation.stars == null"
              block
              depressed
              rounded
              large
              class="white--text font-weight-bold"
              color="black"
              @click="submitOrderOffer"
              >{{ $t('submit') }}
            </v-btn>
          </v-col>
        </v-col>
        <v-col v-else cols="12" class="pa-0">
          <v-alert dense text type="success">
            Evaluation <strong>successfully</strong> submitted
          </v-alert>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import EventBus from '@/helpers/event-bus';
import util from '@/mixins/util';

export default {
  name: 'OrderEvaluationByResearcher',
  mixins: [util],
  data() {
    return {
      valid: false,
      evaluation: {
        uuid: null,
        stars: null,
        feedback: null,
        type: null,
      },
      evaluationSubmitted: false,
    };
  },
  mounted() {
    this.evaluation.uuid = this.$route.query.uuid;
    this.evaluation.type = this.$route.query.type;
  },
  methods: {
    submitOrderOffer() {
      EventBus.$emit('waiting', true);
      if (this.evaluation.type === 'equipment') {
        this.axios
          .post(
            '/api/v1/orders-equipment/evaluation-by-researcher?uuid=' + this.evaluation.uuid,
            this.evaluation,
          )
          .then(() => {
            console.log('Success');
            EventBus.$emit('snackbar', {
              text: 'Evaluation successfully submitted',
            });
            this.evaluationSubmitted = true;
          })
          .catch(error => {
            console.log(error);
          })
          .finally(EventBus.$emit('waiting', false));
      } else if (this.order.type === 'patent') {
        this.axios
          .post(
            '/api/v1/orders-patent/evaluation-by-researcher?uuid=' + this.evaluation.uuid,
            this.evaluation,
          )
          .then(() => {
            console.log('Success');
            EventBus.$emit('snackbar', {
              text: 'Evaluation successfully submitted',
            });
            this.evaluationSubmitted = true;
          })
          .catch(error => {
            console.log(error);
          })
          .finally(EventBus.$emit('waiting', false));
      } else {
        this.axios
          .post(
            '/api/v1/orders/evaluation-by-researcher?uuid=' + this.evaluation.uuid,
            this.evaluation,
          )
          .then(() => {
            console.log('Success');
            EventBus.$emit('snackbar', {
              text: 'Evaluation successfully submitted',
            });
            this.evaluationSubmitted = true;
          })
          .catch(error => {
            console.log(error);
          })
          .finally(EventBus.$emit('waiting', false));
      }
    },
  },
};
</script>
